import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

export type StatusFilter = 'all' | 'depleted' | 'nearly_depleted' | 'predicted';
export type TopupFilter = 'all' | 'has_topup' | 'no_topup';

interface DepletionTableFiltersProps {
  statusFilter: StatusFilter;
  topupFilter: TopupFilter;
  onStatusFilterChange: (value: StatusFilter) => void;
  onTopupFilterChange: (value: TopupFilter) => void;
  totalCount: number;
  filteredCount: number;
}

export function DepletionTableFilters({
  statusFilter,
  topupFilter,
  onStatusFilterChange,
  onTopupFilterChange,
  totalCount,
  filteredCount,
}: DepletionTableFiltersProps) {
  return (
    <div className="flex flex-wrap items-center gap-4 bg-card border rounded-lg p-4">
      <div className="flex items-center gap-2">
        <span className="text-sm text-muted-foreground whitespace-nowrap">สถานะ:</span>
        <Select value={statusFilter} onValueChange={(v) => onStatusFilterChange(v as StatusFilter)}>
          <SelectTrigger className="w-[140px]">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">ทั้งหมด</SelectItem>
            <SelectItem value="depleted">🔴 หมดคอร์ส</SelectItem>
            <SelectItem value="nearly_depleted">🟡 ใกล้หมดคอร์ส</SelectItem>
            <SelectItem value="predicted">🔮 คาดว่าจะหมด</SelectItem>
          </SelectContent>
        </Select>
      </div>

      <div className="flex items-center gap-2">
        <span className="text-sm text-muted-foreground whitespace-nowrap">การเติมชม.:</span>
        <Select value={topupFilter} onValueChange={(v) => onTopupFilterChange(v as TopupFilter)}>
          <SelectTrigger className="w-[160px]">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">ทั้งหมด</SelectItem>
            <SelectItem value="has_topup">มีการเติมชม.</SelectItem>
            <SelectItem value="no_topup">ไม่มีการเติมชม.</SelectItem>
          </SelectContent>
        </Select>
      </div>

      <div className="ml-auto text-sm text-muted-foreground">
        แสดง {filteredCount} จาก {totalCount} รายการ
      </div>
    </div>
  );
}
